
import { Injectable } from '@angular/core';
import { L10n as L10nService, L10nBase } from '@skylab-shared/core';
import { Wrapper } from '../wrapper/wrapper';

export { L10nBase };

@Injectable({providedIn: 'root'})
@Wrapper(L10nService, { static: true })
export class L10n { }
